import { createSlice } from "@reduxjs/toolkit";

const initialKelurahanState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  kelurahanForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const kelurahanSlice = createSlice({
  name: "kelurahan",
  initialState: initialKelurahanState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    kelurahanFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    kelurahanAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    kelurahanCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.kelurahan.push(action.payload.kelurahan);
    },
    kelurahanDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.kelurahan.filter(
        (el) => el.kelurahan_id !== action.payload.id
      );
    },
    getKelurahan: (state, action) => {
      state.actionsLoading = false;
      state.kelurahanForEdit = action.payload.kelurahanForEdit;
      state.error = null;
    },
    // updateProduct
    kelurahanUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.kelurahan = state.entities.kelurahan.map((entity) => {
        if (entity.kelurahan_id === action.payload.kelurahan.kelurahan_id) {
          return action.payload.kelurahan;
        }
        return entity;
      });
    },
  },
});
